<template>
  <el-dialog
    id="formula-form"
    width="55%"
    :visible.sync="addFormDialog"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :inline="true"
      :model="formulaData"
      :rules="formRules"
      ref="fomulaForm"
      label-position="top"
      label-width="100%"
    >
      <div class="form-separator w-full px-2 py-2 my-4 text-center">
        Formula Data
      </div>
      <el-form-item class="w-full mb-0" prop="VarName">
        <el-input
          v-model="formulaData.VarName"
          autocomplete="off"
          placeholder="Variable Name"
        ></el-input>
      </el-form-item>
      <div
        class="text-xs font-bold italic flex space-x-0 space-y-2 lg:space-x-2 lg:space-y-0 pt-2"
      >
        <span class="text-red-600">*</span>Variable Name must be unique
      </div>

      <div class="form-separator w-full px-2 py-2 my-4 text-center">
        Formula Operations
      </div>

      <div class="flex w-full mb-4">
        <div class="w-1/2 flex-wrap content-center">
          <el-form-item class="w-full mb-0" prop="VarType_1">
            <el-select
              v-model="formulaData.VarType_1"
              style="display: block;"
              filterable
              clearable
              default-first-option
              placeholder="Select Variable Type"
              @change="resetSensorSourceValue(1)"
            >
              <el-option
                v-for="(item, index) in varType"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="flex flex-wrap content-center" style="width: 34%;"></div>

        <div class="w-1/2 flex-wrap content-center">
          <el-form-item class="w-full mb-0" prop="VarType_2">
            <el-select
              v-model="formulaData.VarType_2"
              style="display: block;"
              filterable
              clearable
              default-first-option
              placeholder="Select Variable Type"
              @change="resetSensorSourceValue(2)"
            >
              <el-option
                v-for="(item, index) in varType"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <div class="flex">
        <div class="w-1/2 flex-wrap content-center">
          <div class="w-full">
            <el-form-item
              class="w-full pr-4"
              v-if="
                formulaData.VarType_1 !== 'constant' &&
                formulaData.VarType_1 !== 'constant_master'
              "
              prop="Source_1"
            >
              <el-select
                v-model="formulaData.Source_1"
                style="display: block;"
                filterable
                clearable
                default-first-option
                placeholder="Select Variable 1"
                @change="sourceOneChanged"
              >
                <!-- formula sensor list -->
                <template v-if="formulaData.VarType_1 == 'sensor'">
                  <el-option-group
                    v-for="(sensors, index) in getActiveVariables(1)"
                    :key="index"
                    :label="index"
                  >
                    <el-option
                      v-for="item in sensors"
                      :label="item.SensorName"
                      :value="item.DceSensorId"
                    >
                    </el-option>
                  </el-option-group>
                </template>
                <!-- formula sensor list -->
                <!-- others formula list -->
                <template v-else>
                  <el-option
                    v-for="item in getActiveVariables(1)"
                    :label="item.SensorName"
                    :value="item.DceSensorId"
                  />
                </template>
                <!-- others formula list -->
              </el-select>
            </el-form-item>

            <el-form-item
              class="w-full pr-4"
              v-if="formulaData.VarType_1 === 'constant_master'"
              prop="Source_1"
            >
              <el-select
                v-model="formulaData.Source_1_constant"
                style="display: block;"
                filterable
                clearable
                default-first-option
                placeholder="Select Master Constanta"
                @change="masterConstantaChanged(1)"
              >
                <el-option
                  v-for="(item, index) in formulaConstanta"
                  :key="index"
                  :label="item.VarName"
                  :value="item.VarName"
                >
                  <span style="float: left;">{{ item.VarName }}</span>
                  <span
                    style="float: right; color: #8492a6; font-size: 13px;"
                    >{{ item.Source_1 }}</span
                  >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              class="w-full pr-4"
              v-if="formulaData.VarType_1 === 'constant'"
              prop="Source_1_constant"
            >
              <el-input
                v-model="formulaData.Source_1_constant"
                autocomplete="off"
                placeholder="Variable 1 value"
                v-input-mask
                data-inputmask="'alias': 'currency', 'allowMinus': false, 'digits': 4"
                @change="constantaChanged(1)"
              ></el-input>
            </el-form-item>

            <el-form-item
              class="w-full pr-4"
              v-if="formulaData.VarType_1 === 'sensor'"
              prop="ProcessForm_1"
            >
              <el-select
                v-model="formulaData.ProcessForm_1"
                style="display: block;"
                placeholder="Select Function 1"
                filterable
                clearable
                :disabled="formulaData.VarType_1 !== 'sensor'"
              >
                <el-option
                  v-for="(item, index) in operators"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="flex flex-wrap content-center">
          <div class="w-full">
            <el-form-item label="" prop="OperationFormula">
              <el-select
                v-model="formulaData.OperationFormula"
                placeholder="Operator"
                style="display: block;"
                filterable
                clearable
              >
                <el-option
                  v-for="item in formulaOperation"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="w-1/2 flex-wrap content-center">
          <div class="w-full">
            <el-form-item
              class="w-full pl-4"
              v-if="
                formulaData.VarType_2 !== 'constant' &&
                formulaData.VarType_2 !== 'constant_master'
              "
              prop="Source_2"
            >
              <el-select
                v-model="formulaData.Source_2"
                style="display: block;"
                filterable
                clearable
                default-first-option
                placeholder="Select Variable 2"
                @change="sourceTwoChanged"
              >
                <!-- formula sensor list -->
                <template v-if="formulaData.VarType_2 == 'sensor'">
                  <el-option-group
                    v-for="(sensors, index) in getActiveVariables(2)"
                    :key="index"
                    :label="index"
                  >
                    <el-option
                      v-for="item in sensors"
                      :label="item.SensorName"
                      :value="item.DceSensorId"
                    >
                    </el-option>
                  </el-option-group>
                </template>
                <!-- formula sensor list -->
                <!-- others formula list -->
                <template v-else>
                  <el-option
                    v-for="item in getActiveVariables(2)"
                    :label="item.SensorName"
                    :value="item.DceSensorId"
                  />
                </template>
                <!-- others formula list -->
              </el-select>
            </el-form-item>

            <el-form-item
              class="w-full pl-4"
              v-if="formulaData.VarType_2 === 'constant_master'"
              prop="Source_2"
            >
              <el-select
                v-model="formulaData.Source_2_constant"
                style="display: block;"
                filterable
                clearable
                default-first-option
                placeholder="Select Master Constanta"
                @change="masterConstantaChanged(2)"
              >
                <el-option
                  v-for="(item, index) in formulaConstanta"
                  :key="index"
                  :label="item.VarName"
                  :value="item.VarName"
                >
                  <span style="float: left;">{{ item.VarName }}</span>
                  <span
                    style="float: right; color: #8492a6; font-size: 13px;"
                    >{{ item.Source_1 }}</span
                  >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              class="w-full pl-4"
              v-if="formulaData.VarType_2 === 'constant'"
              prop="Source_2_constant"
            >
              <el-input
                v-model="formulaData.Source_2_constant"
                autocomplete="off"
                placeholder="Variable 2 value"
                v-input-mask
                data-inputmask="'alias': 'currency', 'allowMinus': false, 'digits': 4"
                @change="constantaChanged(2)"
              ></el-input>
            </el-form-item>

            <el-form-item
              class="w-full pl-4"
              v-if="formulaData.VarType_2 === 'sensor'"
              prop="ProcessForm_2"
            >
              <el-select
                v-model="formulaData.ProcessForm_2"
                style="display: block;"
                placeholder="Select Function 2"
                filterable
                clearable
                :disabled="formulaData.VarType_2 !== 'sensor'"
              >
                <el-option
                  v-for="(item, index) in operators"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('cancel-form', $event)">Cancel</el-button>
      <el-button v-if="typeForm === 'Add'" type="primary" @click="saveForm"
        >Add Formula</el-button
      >
      <el-button v-if="typeForm === 'Edit'" type="primary" @click="updateForm"
        >Update</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    formulaData: {
      type: Object,
      required: true
    },
    addFormDialog: {
      type: Boolean
    },
    typeForm: {
      type: String
    },
    operators: {
      type: Array
    },
    formulaSensor: {
      type: Array
    },
    formulaSensorGroupped: {
      type: Object
    },
    formulaCustom: {
      type: Array
    },
    formulaConstanta: {
      type: Array
    },
    formulaOperation: {
      type: Array
    }
  },
  data() {
    return {
      varType: [
        {
          value: 'sensor',
          label: 'Sensor'
        },
        {
          value: 'constant',
          label: 'Constanta'
        },
        {
          value: 'constant_master',
          label: 'Master Constanta'
        },
        {
          value: 'process',
          label: 'Other Formula'
        }
      ],
      formRules: {
        VarName: [
          {
            required: true,
            message: 'Variable Name is required',
            trigger: 'change'
          }
        ],
        Source_1: [
          {
            required: true,
            message: 'Variable 1 is required',
            trigger: 'change'
          }
        ],
        Source_1_constant: [
          {
            required: true,
            message: 'Variable 1 is required',
            trigger: 'change'
          }
        ],
        ProcessForm_1: [
          {
            required: true,
            message: 'Function 1 is required',
            trigger: 'change'
          }
        ],
        VarType_1: [
          {
            required: true,
            message: 'Variable Type 1 is required',
            trigger: 'change'
          }
        ],
        Source_2: [
          {
            required: true,
            message: 'Variable 2 is required',
            trigger: 'change'
          }
        ],
        Source_2_constant: [
          {
            required: true,
            message: 'Variable 2 is required',
            trigger: 'change'
          }
        ],
        ProcessForm_2: [
          {
            required: true,
            message: 'Function 2 is required',
            trigger: 'change'
          }
        ],
        VarType_2: [
          {
            required: true,
            message: 'Variable Type 2 is required',
            trigger: 'change'
          }
        ],
        OperationFormula: [
          {
            required: true,
            message: 'Operator is required',
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    sourceOneChanged(val) {
      var formula = this.formulaSensor.find((x) => x.DceSensorId === val)
      if (formula) {
        this.formulaData.Source_1_Name = `${formula.SensorName} - (${formula.DeviceDceName})`
      }

      if (this.formulaData.VarType_1 === 'process') {
        this.formulaData.Source_1 = val
        this.formulaData.Source_1_Name = val
      }
    },
    sourceTwoChanged(val) {
      var formula = this.formulaSensor.find((x) => x.DceSensorId === val)
      if (formula) {
        this.formulaData.Source_2_Name = `${formula.SensorName} - (${formula.DeviceDceName})`
      }

      if (this.formulaData.VarType_2 === 'process') {
        this.formulaData.Source_2 = val
        this.formulaData.Source_2_Name = val
      }
    },
    masterConstantaChanged(source) {
      var constant = null
      if (source == 1) {
        constant = this.formulaConstanta.find(
          (x) => x.VarName === this.formulaData.Source_1_constant
        )
        if (constant) {
          this.formulaData.Source_1 = constant.Source_1
          this.formulaData.Source_1_Name =
            constant.VarName + ` (${constant.Source_1})`
        }
      } else if (source == 2) {
        constant = this.formulaConstanta.find(
          (x) => x.VarName === this.formulaData.Source_2_constant
        )
        if (constant) {
          this.formulaData.Source_2 = constant.Source_1
          this.formulaData.Source_2_Name =
            constant.VarName + ` (${constant.Source_1})`
        }
      }
    },
    constantaChanged(source) {
      var constant = null
      if (source == 1) {
        constant = this.formulaData.Source_1_constant
        if (constant) {
          this.formulaData.Source_1 = constant
          this.formulaData.Source_1_Name = `Constanta (${constant})`
        }
      } else if (source == 2) {
        constant = this.formulaData.Source_2_constant
        if (constant) {
          this.formulaData.Source_2 = constant
          this.formulaData.Source_2_Name = `Constanta (${constant})`
        }
      }
    },
    getVarTypeBySource(source) {
      if (source === 1) {
        return this.formulaData.VarType_1
      } else if (source === 2) {
        return this.formulaData.VarType_2
      }
    },
    getActiveVariables(source) {
      var type = this.getVarTypeBySource(source)

      if (type === 'sensor') {
        return this.formulaSensorGroupped
      } else if (type === 'constant_master') {
        return this.formulaConstanta
      } else if (type === 'process') {
        return this.formulaCustom
          .map((x) => ({
            SensorName: x.VarName,
            DceSensorId: x.VarName
          }))
          .filter((x) => x.SensorName !== this.formulaData.VarName)
      }
    },
    resetSensorSourceValue(source) {
      if (source === 1) {
        this.formulaData.Source_1 = ''
        this.formulaData.Source_1_Name = ''
        this.formulaData.Source_1_constant = ''
        this.formulaData.ProcessForm_1 = ''
      } else if (source === 2) {
        this.formulaData.Source_2 = ''
        this.formulaData.Source_2_Name = ''
        this.formulaData.Source_2_constant = ''
        this.formulaData.ProcessForm_2 = ''
      }

      if (
        (source === 1 && this.formulaData.VarType_1 === 'constant_master') ||
        (source === 2 && this.formulaData.VarType_2 === 'constant_master')
      ) {
        this.$emit('fetch-constanta', true)
      }
    },
    saveForm() {
      this.$refs['fomulaForm'].validate(async (valid) => {
        if (valid) {
          this.$emit('save-form', this.$event)
        } else {
          this.$message.warning('Please fill in the required data')
          return false
        }
      })
    },
    updateForm() {
      this.$refs['fomulaForm'].validate(async (valid) => {
        if (valid) {
          this.$emit('update-form', this.$event)
        } else {
          this.$message.warning('Please fill in the required data')
          return false
        }
      })
    },
    handleClose($event) {
      this.$emit('cancel-form', $event)
    }
  }
  // watch: {
  //   'formulaData.Source_1_constant': function(val) {
  //     if (val) {
  //       this.formulaData.Source_1 = val;
  //       this.formulaData.Source_1_Name = val;
  //     }
  //   },
  //   'formulaData.Source_2_constant': function(val) {
  //     if (val) {
  //       this.formulaData.Source_2 = val;
  //       this.formulaData.Source_2_Name = val;
  //     }
  //   },
  // },
}
</script>

<style>
#formula-form .el-input__inner::placeholder {
  color: #6f6f6f !important;
}
#formula-form .el-form-item__error {
  display: none;
}
#formula-form .el-dialog__body {
  padding: 10px 20px !important;
}
.form-separator {
  background: rgb(30, 130, 200) none repeat scroll 0% 0%;
  color: rgb(255, 255, 255);
  font-style: italic;
}
</style>
